import { h } from '@stencil/core';

export function pureButtonSkeleton(): HTMLElement {
  return (
    <div class="skeleton-container">
      <div class="pure-button-skeleton" />
    </div>
  );
}

export function pureButtonSkeletonDark(): HTMLElement {
  return (
    <div class="skeleton-container">
      <div class="pure-button-skeleton-dark" />
    </div>
  );
}

export function burgerButtonSkeleton(): HTMLElement {
  return (
    <div class="skeleton-container">
      <div class="burger-button-skeleton" />
    </div>
  );
}

export function burgerButtonSkeletonDark(): HTMLElement {
  return (
    <div class="skeleton-container">
      <div class="burger-button-skeleton-dark" />
    </div>
  );
}
